// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

*::-webkit-scrollbar {
  width: 16px;
}

*::-webkit-scrollbar-track {
  border-radius: 0;
}

*::-webkit-scrollbar-thumb {
  height: 56px;
  border-radius: 0;
  border: 4px solid transparent;
  background-clip: content-box;
  background-color: #888;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

body {
  font-family: var(--font-sans);
  background: var(--paper);
  color: var(--ink);
}

#root {
  background: var(--paper);
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n*::-webkit-scrollbar {\n  width: 16px;\n}\n\n*::-webkit-scrollbar-track {\n  border-radius: 0;\n}\n\n*::-webkit-scrollbar-thumb {\n  height: 56px;\n  border-radius: 0;\n  border: 4px solid transparent;\n  background-clip: content-box;\n  background-color: #888;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background-color: #555;\n}\n\nbody {\n  font-family: var(--font-sans);\n  background: var(--paper);\n  color: var(--ink);\n}\n\n#root {\n  background: var(--paper);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
